import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ITypeMarket } from '../../core/interfaces/type-market.interface';
import { GetAllTypeMarketAction } from './type-market.actions';
import { typeMarketData } from '../../data/type-market';

export interface TypeMarketStateModel {
  typeMarket: ITypeMarket[];
}

@State<TypeMarketStateModel>({
  name: 'typeMarket',
  defaults: {
    typeMarket: [],
  },
})
@Injectable()
export class TypeMarketState {
  @Selector() static GetAllData(state: TypeMarketStateModel): ITypeMarket[] {
    return state?.typeMarket ? state?.typeMarket : [];
  }

  typeMarketArray: ITypeMarket[] = [...typeMarketData];

  constructor() {}

  @Action(GetAllTypeMarketAction)
  GetAllTypeMarketAction(ctx: StateContext<TypeMarketStateModel>) {
    ctx.patchState({
      typeMarket: this.typeMarketArray,
    });
  }
}
